<template>
  <path pid="0" d="M21 2H7.5A3.5 3.5 0 004 5.5v15A3.5 3.5 0 007.5 24H21a1 1 0 001-1V3a1 1 0 00-1-1zm-1 20H7.5a1.5 1.5 0 010-3H20zm0-5H7.5a3.41 3.41 0 00-1.5.34V5.5A1.5 1.5 0 017.5 4H20z"/>
</template>
